import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { InfoMessageModalData } from '@app/utils/interfaces/info-message-modal-data.interface';

@Component({
  selector: 'app-info-message-modal',
  standalone: true,
  imports: [IconComponent, TranslatePipe],
  templateUrl: './info-message-modal.component.html',
  styleUrl: './info-message-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoMessageModalComponent {
  protected readonly data = inject<InfoMessageModalData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef<InfoMessageModalComponent>);

  public close(): void {
    this.dialogRef.close();
  }
}
